<template lang="pug">
v-dialog.gestaoCupom(v-model="show", max-width="500", persistent, style="border-radius: 17px!important; overflow: hidden!important;")
  form(:key="formKey", @submit.prevent="validar", data-vv-scope="form", style="width: 100%;")
    v-card.Poppins
      v-card-title.cardApple.headline.Poppins.font-weight-medium {{ isEdicao ? 'Editar Cupom' : 'Cadastrar Cupom' }}
      v-card.cardApple
        v-card-text.py-0
          v-layout(row, wrap)
            v-flex.xs12
              v-text-field.inputDefault(outline, color="gray", label='Quantidade de cupons', v-validate="'required|min_value:1'", :error-messages="errors.collect('form.quantidade')", data-vv-name="quantidade", type='number', v-model='cupom.quantidade')
          v-layout(row, wrap)
            v-flex.xs12
              v-text-field.inputDefault(outline, color="gray", label='Limite de cupom por usuário', v-validate="'required|min_value:1'", :error-messages="errors.collect('form.quantidade_usuario')", data-vv-name="quantidade_usuario", data-vv-as="limite de cupons por usuário", type='number', v-model='cupom.quantidade_usuario', :disabled="!!cupom.id && aplicarEm !== 'entrega'")
          v-layout(row, wrap)
            v-flex.xs12
              .cupomDialog__field-label Aplicar desconto em
              .cupomDialog__chips
                button.cupomDialog__chip(
                  type="button",
                  :disabled="cupom.id ? true : false",
                  :class="{ 'cupomDialog__chip--active': aplicarEm === 'itens' }",
                  @click="!cupom.id && setAplicarEm('itens')"
                ) Nos itens
                button.cupomDialog__chip(
                  type="button",
                  :disabled="cupom.id ? true : false",
                  :class="{ 'cupomDialog__chip--active': aplicarEm === 'entrega' }",
                  @click="!cupom.id && setAplicarEm('entrega')"
                ) Na taxa de entrega
          v-layout.mb-4(d-flex, style="gap: 10px; flex-wrap: nowrap;", row, v-if="aplicarEm === 'itens'")
            v-flex.xs6.areaPontilhada
              label.body-2 Forma de desconto
              v-radio-group(v-model='cupom.tipo_desconto', :disabled='cupom.id ? true : false')
                v-radio(color="primary" label='Valor Fixo' :value='1')
                v-radio(color="primary" label='Percentual' :value='2')
            v-flex.xs6.areaPontilhada
              label.body-2 Exibir cupom na página da loja
              v-radio-group(v-model='cupom.listado')
                v-radio(color="primary" label='Sim' :value='1')
                v-radio(color="primary" label='Não' :value='0')
          v-layout.mb-4(row, wrap, v-else)
            v-flex.xs12.areaPontilhada
              label.body-2 Exibir cupom na página da loja
              v-radio-group(v-model='cupom.listado', row)
                v-radio(color="primary" label='Sim' :value='1')
                v-radio(color="primary" label='Não' :value='0')
          v-layout(row, wrap, v-if="aplicarEm === 'entrega'")
            v-flex.xs12
              .cupomDialog__field-label
                | Pedido mínimo
                span.cupom-smart-badge.Poppins(v-if="isInteligente", style="margin-left:6px;font-size:10px;padding:1px 8px;vertical-align:middle;")
                  v-icon(x-small, style="color:#1d9a5a;") auto_awesome
                  |  Inteligente
              .cupomDialog__chips
                button.cupomDialog__chip(
                  type="button",
                  :disabled="isEdicao",
                  :class="{ 'cupomDialog__chip--active': !minEntregaCustom && (minPedidoEntregaSelecionado === null || minPedidoEntregaSelecionado === 0) }",
                  @click="selecionarMinEntrega(null)"
                ) Sem mínimo
                button.cupomDialog__chip(
                  v-for="op in opcoesPedidoMinimoEntrega",
                  :key="'entmin-' + op.value",
                  type="button",
                  :disabled="isEdicao",
                  :class="{ 'cupomDialog__chip--active': !minEntregaCustom && minPedidoEntregaSelecionado === op.value, 'cupomDialog__chip--smart': op.inteligente }",
                  @click="selecionarMinEntrega(op.value)"
                )
                  | {{ op.label }}
                  v-icon.cupomDialog__chip-smart-icon(v-if="op.inteligente", size="18") auto_awesome
                button.cupomDialog__chip(
                  type="button",
                  :disabled="isEdicao",
                  :class="{ 'cupomDialog__chip--active': minEntregaCustom }",
                  @click="ativarPersonalizado('minEntrega')"
                ) Personalizado
              v-text-field.inputDefault(v-if="minEntregaCustom", outline, color="gray", type="number", prefix="R$", label="Pedido mínimo", v-model="minPedidoEntregaSelecionado", :disabled="isEdicao")
            v-flex.xs12.mt-3
              .cupomDialog__field-label Limite do desconto na entrega
              .cupomDialog__field-hint Limite máximo do desconto aplicado na taxa de entrega.
              .cupomDialog__chips
                button.cupomDialog__chip(
                  type="button",
                  :disabled="isEdicao",
                  :class="{ 'cupomDialog__chip--active': regraDescontoEntrega === 'total' }",
                  @click="selecionarRegraEntrega('total', null)"
                ) Cobrir 100% da entrega
                button.cupomDialog__chip(
                  v-for="v in limiteEntregaPresets",
                  :key="'entlim-' + v",
                  type="button",
                  :disabled="isEdicao",
                  :class="{ 'cupomDialog__chip--active': regraDescontoEntrega === 'limitado' && valorDescontoMaximoEntrega === v }",
                  @click="selecionarRegraEntrega('limitado', v)"
                ) Até R${{ v }}
          v-layout(row, wrap, v-if="aplicarEm === 'itens'")
            v-flex.xs12(v-if="cupom.tipo_desconto == 1")
              .cupomDialog__field-label Valor do cupom
              .cupomDialog__chips
                button.cupomDialog__chip(
                  v-for="v in PRESETS_VALOR_FIXO",
                  :key="v",
                  type="button",
                  :disabled="cupom.id ? true : false",
                  :class="{ 'cupomDialog__chip--active': !valorDescontoCustom && cupom.valor_desconto === v }",
                  @click="selecionarValorDesconto(v)"
                ) R${{ v }}
                button.cupomDialog__chip(
                  type="button",
                  :disabled="cupom.id ? true : false",
                  :class="{ 'cupomDialog__chip--active': valorDescontoCustom }",
                  @click="ativarPersonalizado('valorDesconto')"
                ) Personalizado
              v-text-field.inputDefault(v-if="valorDescontoCustom", outline, color="gray", type="number", prefix="R$", label="Valor do cupom", v-model="cupom.valor_desconto", :disabled="cupom.id ? true : false")
              input(type="hidden", v-model="cupom.valor_desconto", v-validate="'required|min_value:1|max_value:50'", data-vv-name="valor_desconto", data-vv-as="valor do cupom", data-vv-scope="form")
              span.red--text.caption(v-if="errors.has('form.valor_desconto')") {{ errors.first('form.valor_desconto') }}
            v-flex.xs12(v-else)
              template(v-if="cupom.id == null")
                .cupomDialog__field-label Valor do cupom
                .cupomDialog__chips
                  button.cupomDialog__chip(
                    v-for="v in PRESETS_VALOR_PERCENTUAL",
                    :key="v",
                    type="button",
                    :class="{ 'cupomDialog__chip--active': !valorDescontoCustom && cupom.valor_desconto === v }",
                    @click="selecionarValorDesconto(v)"
                  ) {{ v }}%
                  button.cupomDialog__chip(
                    type="button",
                    :class="{ 'cupomDialog__chip--active': valorDescontoCustom }",
                    @click="ativarPersonalizado('valorDesconto')"
                  ) Personalizado
                v-text-field.inputDefault(v-if="valorDescontoCustom", outline, color="gray", type="number", suffix="%", label="Valor do cupom", v-model="cupom.valor_desconto")
                input(type="hidden", v-model="cupom.valor_desconto", v-validate="'required|min_value:10|max_value:90'", data-vv-name="valor_desconto", data-vv-as="valor do cupom", data-vv-scope="form")
                span.red--text.caption(v-if="errors.has('form.valor_desconto')") {{ errors.first('form.valor_desconto') }}
              v-text-field.inputDefault(v-else, outline, color="gray", suffix='%', type="number", label='Valor do cupom', :placeholder="JSON.stringify(cupom.valor_desconto * 100)", :disabled='true')
          v-layout.mt-3(row, wrap, v-if="aplicarEm === 'itens' && cupom.tipo_desconto == 1")
            v-flex.xs12
              .cupomDialog__field-label
                | Pedido mínimo
                span.cupom-smart-badge.Poppins(v-if="isInteligente", style="margin-left:6px;font-size:10px;padding:1px 8px;vertical-align:middle;")
                  v-icon(x-small, style="color:#1d9a5a;") auto_awesome
                  |  Inteligente
              .cupomDialog__chips
                button.cupomDialog__chip(
                  v-for="op in opcoesValorMinimo",
                  :key="op.value",
                  type="button",
                  :disabled="isEdicao",
                  :class="{ 'cupomDialog__chip--active': !valorMinimoCustom && cupom.valor_minimo === op.value, 'cupomDialog__chip--smart': op.inteligente }",
                  @click="selecionarValorMinimo(op.value)"
                )
                  | {{ op.label }}
                  v-icon.cupomDialog__chip-smart-icon(v-if="op.inteligente", size="18") auto_awesome
                button.cupomDialog__chip(
                  type="button",
                  :disabled="isEdicao",
                  :class="{ 'cupomDialog__chip--active': valorMinimoCustom }",
                  @click="ativarPersonalizado('valorMinimo')"
                ) Personalizado
              v-text-field.inputDefault(v-if="valorMinimoCustom", outline, color="gray", type="number", prefix="R$", label="Pedido mínimo", v-model="cupom.valor_minimo", :disabled="isEdicao")
              input(type="hidden", v-model="cupom.valor_minimo", v-validate="'required|min_value:0'", data-vv-name="valor_minimo", data-vv-as="valor mínimo", data-vv-scope="form")
              span.red--text.caption(v-if="errors.has('form.valor_minimo')") {{ errors.first('form.valor_minimo') }}
          v-layout.mt-3(row, wrap, v-if="aplicarEm === 'itens' && cupom.tipo_desconto == 2")
            v-flex.xs12
              .cupomDialog__field-label Desconto máximo (teto)
              .cupomDialog__chips
                button.cupomDialog__chip(
                  v-for="v in PRESETS_DESCONTO_MAXIMO",
                  :key="v",
                  type="button",
                  :disabled="isEdicao",
                  :class="{ 'cupomDialog__chip--active': !descontoMaximoCustom && cupom.valor_desconto_maximo === v }",
                  @click="selecionarDescontoMaximo(v)"
                ) R${{ v }}
                button.cupomDialog__chip(
                  type="button",
                  :disabled="isEdicao",
                  :class="{ 'cupomDialog__chip--active': descontoMaximoCustom }",
                  @click="ativarPersonalizado('descontoMaximo')"
                ) Personalizado
              v-text-field.inputDefault(v-if="descontoMaximoCustom", outline, color="gray", type="number", prefix="R$", label="Desconto máximo", v-model="cupom.valor_desconto_maximo", :disabled="isEdicao")
              input(type="hidden", v-model="cupom.valor_desconto_maximo", :v-validate="cupom.tipo_desconto == 2 ? 'required' : ''", data-vv-name="valor_desconto_maximo", data-vv-as="valor desconto máximo", data-vv-scope="form")
              span.red--text.caption(v-if="errors.has('form.valor_desconto_maximo')") {{ errors.first('form.valor_desconto_maximo') }}
          v-layout.mb-4(d-flex, style="gap: 10px; flex-wrap: nowrap;", row)
            v-flex.xs12.areaPontilhada
              label.body-2 Restrição de uso
              v-radio-group(v-model='cupom.primeiro_pedido_estabelecimento', :disabled='cupom.id ? true : false', row)
                v-radio(color="primary", label='Para qualquer pedido', :value='0')
                v-radio(color="primary", label='Apenas primeiro pedido no estabelecimento', :value='1')
          v-layout.mb-4(row, wrap)
            v-flex.xs12.areaPontilhada
              v-radio-group(v-model='cupom.vigencia', row, d-flex, align-content-space-around)
                v-radio(color="primary", label='Sem vigência' :value='0')
                v-radio(color="primary", label='Com vigência' :value='1')
          v-layout(row, wrap, v-if="cupom.vigencia == 1")
            v-flex.xs12
              .cupomDialog__field-label Período de validade
              .cupomDialog__chips
                button.cupomDialog__chip(
                  type="button",
                  :class="{ 'cupomDialog__chip--active': vigenciaPreset === '14d' }",
                  @click="aplicarPresetVigencia('14d')"
                ) 14 dias
                button.cupomDialog__chip(
                  type="button",
                  :class="{ 'cupomDialog__chip--active': vigenciaPreset === '28d' }",
                  @click="aplicarPresetVigencia('28d')"
                ) 28 dias
                button.cupomDialog__chip(
                  type="button",
                  :class="{ 'cupomDialog__chip--active': vigenciaPreset === '3m' }",
                  @click="aplicarPresetVigencia('3m')"
                ) 3 meses
                button.cupomDialog__chip(
                  type="button",
                  :class="{ 'cupomDialog__chip--active': vigenciaPreset === 'personalizado' }",
                  @click="aplicarPresetVigencia('personalizado')"
                ) Personalizado
            template(v-if="vigenciaPreset !== null")
              v-flex.xs6
                v-text-field.inputDefault(outline, type="date", color="gray", label="Data Inicial", v-model="cupom.data_inicio", v-validate="'required'", :error-messages="errors.collect('form.data_inicio')", data-vv-name="data_inicio", data-vv-as="data inicial", :disabled="vigenciaPreset !== 'personalizado'")
              v-flex.xs6.pl-1
                v-text-field.inputDefault(outline, type="date", color="gray", label="Data Final", v-model="cupom.data_fim", v-validate="'required'", :error-messages="errors.collect('form.data_fim')", data-vv-name="data_fim", data-vv-as="data fim", :disabled="vigenciaPreset !== 'personalizado'")
          v-layout.mt-3(row, wrap)
            v-flex.xs12
              .cupomDialog__field-label Dias da semana
              .cupomDialog__chips
                button.cupomDialog__chip(
                  type="button",
                  :class="{ 'cupomDialog__chip--active': diasSemanaTodos }",
                  @click="selecionarTodosDias"
                ) Todos os dias
                button.cupomDialog__chip(
                  type="button",
                  :class="{ 'cupomDialog__chip--active': diasSemanaUteis }",
                  @click="selecionarDiasUteis"
                ) Dias úteis
              .cupomDialog__chips.mt-1
                button.cupomDialog__chip(
                  v-for="d in DIAS_SEMANA",
                  :key="'dia-' + d.id",
                  type="button",
                  :class="{ 'cupomDialog__chip--active': diasSemanaSel.includes(d.id) }",
                  @click="toggleDiaSemana(d.id)"
                ) {{ d.label }}
              span.red--text.caption(v-if="!diasSemanaSel.length") Selecione pelo menos um dia da semana.
          v-layout(row, wrap)
            v-flex.xs12
              v-text-field.inputDefault.cupom-codigo-input(outline, color="gray", label='Código do cupom', :maxlength="cupom.id ? null : 10", :rules="[requiredRule, minLengthRule]", :error-messages="errors.collect('form.codigo')", v-model='cupom.codigo', :disabled='cupom.id ? true : false', focusable)
        v-card-actions
          v-spacer
          v-btn(flat, :disabled="loading", type="button", @click="close") Fechar
          v-btn.padraoBtn.white--text(color="primary", :loading="loading", type="submit") Salvar
</template>

<script>
import _ from 'lodash';
import { gerarCodigoCupom, montarPayloadCupom, detectarPresetVigencia } from '@/util/cupom';

function novoCupom () {
  return {
    tipo_desconto: 1,
    listado: 1,
    valor_minimo: 0,
    valor_desconto: 5,
    valor_desconto_maximo: null,
    valor_maximo: null,
    vigencia: 0,
    quantidade: 50,
    quantidade_usuario: 1,
    primeiro_pedido_estabelecimento: 0,
    codigo: '',
    data_inicio: null,
    data_fim: null,
  };
}

export default {
  name: 'DialogCupomForm',
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    // Métricas de 28 dias da loja (ticket médio / taxa média) — usadas nas sugestões.
    metricas28d: {
      type: Object,
      default: null,
    },
    // Lista de cupons da loja — usada para checar código duplicado ao cadastrar.
    cupons: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      show: false,
      loading: false,
      // Incrementado a cada open() para forçar a remontagem do formulário —
      // garante que radios/chips inicializem com o cupom recém-carregado.
      formKey: 0,
      // Modo "Personalizado" de cada campo (input livre em vez de chip de preset).
      valorDescontoCustom: false,
      valorMinimoCustom: false,
      descontoMaximoCustom: false,
      minEntregaCustom: false,
      cupom: novoCupom(),
      aplicarEm: 'itens',
      regraDescontoEntrega: null,
      valorDescontoMaximoEntrega: null,
      minPedidoEntregaSelecionado: null,
      vigenciaPreset: null,
      diasSemanaSel: [0, 1, 2, 3, 4, 5, 6],
      DIAS_SEMANA: [
        { id: 0, label: 'DOM' },
        { id: 1, label: 'SEG' },
        { id: 2, label: 'TER' },
        { id: 3, label: 'QUA' },
        { id: 4, label: 'QUI' },
        { id: 5, label: 'SEX' },
        { id: 6, label: 'SÁB' },
      ],
      PRESETS_VALOR_FIXO: [5, 7, 10, 15],
      PRESETS_VALOR_PERCENTUAL: [10, 15, 25, 50],
      PRESETS_DESCONTO_MAXIMO: [5, 7, 10, 15],
      MIN_ENTREGA_PRESETS: [20, 30, 40, 50, 60, 80, 100],
      LIMITE_DESCONTO_ENTREGA_PRESETS: [5, 7, 10, 12, 15],
      minLengthRule: v => (v && v.length >= 5) || 'O código deve ter no mínimo 5 caractéres \n',
      requiredRule: v => !!v || 'Preencha este campo',
    };
  },
  computed: {
    estabelecimento () {
      return this.$root.estabelecimentoSelecionado;
    },
    isCardapioDigital () {
      return !!(this.estabelecimento && this.estabelecimento.cardapio_digital);
    },
    isEdicao () {
      return !!this.cupom.id;
    },
    isInteligente () {
      return !!this.metricas28d;
    },
    opcoesValorMinimo () {
      const desconto = Number(this.cupom.valor_desconto) || 0;
      const m = this.metricas28d;
      const r5 = (v) => Math.ceil(v / 5) * 5;
      // Opções fixas (mesmo conjunto do pedido mínimo da entrega).
      const FIXOS = [20, 30, 40, 50, 60, 80, 100];
      const smart = new Set();
      if (m && m.ticketMedio) {
        const t = m.ticketMedio;
        [r5(t * 0.7), r5(t), r5(t * 1.3), r5(t * 1.6)].forEach(v => smart.add(v));
      }
      const combinado = new Set([...FIXOS, ...smart]);
      const unicos = [...combinado].filter(v => v > desconto).sort((a, b) => a - b);
      return [
        { label: 'Sem mínimo', value: 0, inteligente: false },
        ...unicos.map(v => ({ label: `R$${v}`, value: v, inteligente: smart.has(v) })),
      ];
    },
    opcoesPedidoMinimoEntrega () {
      // Pedido mínimo da entrega — fixos + sugestões inteligentes (sem filtro por desconto).
      const m = this.metricas28d;
      const r5 = (v) => Math.ceil(v / 5) * 5;
      const FIXOS = [20, 30, 40, 50, 60, 80, 100];
      const smart = new Set();
      if (m && m.ticketMedio) {
        const t = m.ticketMedio;
        [r5(t * 0.7), r5(t), r5(t * 1.3), r5(t * 1.6)].forEach(v => smart.add(v));
      }
      const combinado = new Set([...FIXOS, ...smart]);
      const unicos = [...combinado].filter(v => v > 0).sort((a, b) => a - b);
      return unicos.map(v => ({ label: `R$${v}`, value: v, inteligente: smart.has(v) }));
    },
    limiteEntregaPresets () {
      return this.injetarValorExato(this.LIMITE_DESCONTO_ENTREGA_PRESETS, this.isEdicao ? this.valorDescontoMaximoEntrega : null);
    },
    diasSemanaTodos () {
      return this.diasSemanaSel.length === 7;
    },
    diasSemanaUteis () {
      const set = new Set(this.diasSemanaSel);
      return set.size === 5 && [1, 2, 3, 4, 5].every(d => set.has(d));
    },
  },
  watch: {
    'cupom.tipo_desconto': {
      handler (newValue, oldValue) {
        // Só reage a troca manual de tipo num cupom NOVO. A guarda !this.cupom.id
        // impede que a reatribuição do objeto cupom (ao abrir a edição) corrompa
        // um cupom já criado.
        if (newValue != oldValue && this.show && !this.cupom.id) {
          this.cupom.valor_minimo = 0;
          this.cupom.valor_desconto_maximo = null;
          if (newValue == 1) {
            this.cupom.valor_desconto = 5;
          } else {
            this.cupom.valor_desconto = 10;
            this.cupom.valor_desconto_maximo = 5;
          }
          // Troca de tipo volta os campos para os presets.
          this.valorDescontoCustom = false;
          this.valorMinimoCustom = false;
          this.descontoMaximoCustom = false;
        }
      },
      deep: true,
    },
    'cupom.vigencia' (newVal, oldVal) {
      if (newVal == 1 && oldVal != 1 && !this.vigenciaPreset && !this.cupom.id) {
        this.aplicarPresetVigencia('3m');
      }
    },
    'cupom.valor_desconto' (newVal, oldVal) {
      if (newVal !== oldVal && this.show && !this.cupom.id) {
        this.cupom.valor_minimo = 0;
        this.valorMinimoCustom = false;
      }
    },
  },
  mounted () {
    this.$validator.pause();
  },
  methods: {
    // Abre o modal para cadastro (sem argumento) ou edição (cupom da lista).
    open (cupom) {
      const dayjs = this.$dayjs;
      const obj = cupom ? _.cloneDeep(cupom) : novoCupom();

      // Força a remontagem do formulário para que radios/chips inicializem
      // com os valores deste cupom (evita estado preso de uma abertura anterior).
      this.formKey++;

      // 'listado' pode vir null em cupons antigos; o v-radio só casa com o valor
      // exato (1/0), então normaliza para o radio refletir o estado salvo.
      obj.listado = obj.listado == 1 ? 1 : 0;

      // O driver MySQL devolve colunas DECIMAL como string; converte para number
      // para os chips de preset casarem com o valor salvo.
      ['valor_desconto', 'valor_minimo', 'valor_desconto_maximo'].forEach(function (k) {
        if (obj[k] != null && obj[k] !== '') obj[k] = Number(obj[k]);
      });

      obj.data_inicio = obj.data_inicio && dayjs(obj.data_inicio).isValid()
        ? dayjs(obj.data_inicio).format('YYYY-MM-DD')
        : null;
      obj.data_fim = obj.data_fim && dayjs(obj.data_fim).isValid()
        ? dayjs(obj.data_fim).format('YYYY-MM-DD')
        : null;

      this.vigenciaPreset = detectarPresetVigencia(obj.data_inicio, obj.data_fim);
      this.aplicarEm = obj.taxa_entrega == 1 ? 'entrega' : 'itens';

      if (this.aplicarEm === 'entrega') {
        this.minPedidoEntregaSelecionado = obj.valor_minimo > 0 ? Number(obj.valor_minimo) : null;
        this.regraDescontoEntrega = obj.valor_desconto_maximo ? 'limitado' : (obj.id ? 'total' : null);
        this.valorDescontoMaximoEntrega = obj.valor_desconto_maximo ? Number(obj.valor_desconto_maximo) : null;
      } else {
        this.minPedidoEntregaSelecionado = null;
        this.regraDescontoEntrega = null;
        this.valorDescontoMaximoEntrega = null;
      }

      this.diasSemanaSel = obj.dias_semana
        ? obj.dias_semana.split(',').map(n => parseInt(n, 10)).filter(n => !isNaN(n))
        : [0, 1, 2, 3, 4, 5, 6];

      this.cupom = obj;

      // Modo personalizado: na edição, valor fora dos presets abre o input livre.
      this.valorDescontoCustom = !!obj.id && obj.tipo_desconto == 1
        && obj.valor_desconto != null
        && this.PRESETS_VALOR_FIXO.indexOf(obj.valor_desconto) === -1;
      this.descontoMaximoCustom = !!obj.id && obj.tipo_desconto == 2
        && obj.valor_desconto_maximo != null
        && this.PRESETS_DESCONTO_MAXIMO.indexOf(obj.valor_desconto_maximo) === -1;
      this.minEntregaCustom = !!obj.id && this.aplicarEm === 'entrega'
        && this.minPedidoEntregaSelecionado != null
        && !this.opcoesPedidoMinimoEntrega.some(o => o.value === this.minPedidoEntregaSelecionado);
      this.valorMinimoCustom = !!obj.id && this.aplicarEm === 'itens' && obj.tipo_desconto == 1
        && obj.valor_minimo > 0
        && !this.opcoesValorMinimo.some(o => o.value === obj.valor_minimo);

      if (!obj.id) {
        this.cupom.codigo = gerarCodigoCupom(this.cupom, this.estabelecimento && this.estabelecimento.nome);
      }
      this.$validator.resume();
      this.show = true;
    },
    close () {
      this.$validator.pause();
      this.show = false;
      this.vigenciaPreset = null;
      this.cupom = novoCupom();
      this.aplicarEm = 'itens';
      this.minPedidoEntregaSelecionado = null;
      this.regraDescontoEntrega = null;
      this.valorDescontoMaximoEntrega = null;
      this.diasSemanaSel = [0, 1, 2, 3, 4, 5, 6];
      this.valorDescontoCustom = false;
      this.valorMinimoCustom = false;
      this.descontoMaximoCustom = false;
      this.minEntregaCustom = false;
    },
    // Acrescenta o valor exato salvo aos presets quando ele não está na lista (edição).
    injetarValorExato (presets, valor) {
      const lista = presets.slice();
      if (valor != null && valor !== 0 && lista.indexOf(valor) === -1) {
        lista.push(valor);
        lista.sort((a, b) => a - b);
      }
      return lista;
    },
    setAplicarEm (modo) {
      this.aplicarEm = modo;
      if (modo === 'entrega') {
        this.cupom.tipo_desconto = 2;
        this.cupom.valor_desconto = null;
        this.cupom.valor_minimo = 0;
        this.cupom.valor_desconto_maximo = null;
        this.minPedidoEntregaSelecionado = null;
        this.regraDescontoEntrega = null;
        this.valorDescontoMaximoEntrega = null;
      } else {
        this.cupom.tipo_desconto = 1;
        this.cupom.valor_desconto = null;
        this.cupom.valor_minimo = 0;
        this.cupom.valor_desconto_maximo = null;
      }
    },
    selecionarMinEntrega (v) {
      if (this.isEdicao) return;
      this.minEntregaCustom = false;
      this.minPedidoEntregaSelecionado = v;
    },
    selecionarRegraEntrega (regra, valor) {
      if (this.isEdicao) return;
      this.regraDescontoEntrega = regra;
      this.valorDescontoMaximoEntrega = valor;
    },
    selecionarValorDesconto (v) {
      if (this.isEdicao) return;
      this.valorDescontoCustom = false;
      this.cupom.valor_desconto = v;
    },
    selecionarValorMinimo (v) {
      if (this.isEdicao) return;
      this.valorMinimoCustom = false;
      this.cupom.valor_minimo = v;
    },
    selecionarDescontoMaximo (v) {
      if (this.isEdicao) return;
      this.descontoMaximoCustom = false;
      this.cupom.valor_desconto_maximo = v;
    },
    // Ativa o modo "Personalizado" (input livre) do campo informado.
    ativarPersonalizado (campo) {
      if (this.isEdicao) return;
      if (campo === 'valorDesconto') this.valorDescontoCustom = true;
      else if (campo === 'valorMinimo') this.valorMinimoCustom = true;
      else if (campo === 'descontoMaximo') this.descontoMaximoCustom = true;
      else if (campo === 'minEntrega') this.minEntregaCustom = true;
    },
    selecionarTodosDias () {
      this.diasSemanaSel = [0, 1, 2, 3, 4, 5, 6];
    },
    selecionarDiasUteis () {
      this.diasSemanaSel = [1, 2, 3, 4, 5];
    },
    toggleDiaSemana (dia) {
      if (this.diasSemanaSel.includes(dia)) {
        this.diasSemanaSel = this.diasSemanaSel.filter(d => d !== dia);
      } else {
        this.diasSemanaSel = [...this.diasSemanaSel, dia];
      }
    },
    aplicarPresetVigencia (preset) {
      const hoje = this.$dayjs();
      this.vigenciaPreset = preset;
      if (preset === '14d') {
        this.cupom.data_inicio = hoje.format('YYYY-MM-DD');
        this.cupom.data_fim = hoje.add(14, 'day').format('YYYY-MM-DD');
      } else if (preset === '28d') {
        this.cupom.data_inicio = hoje.format('YYYY-MM-DD');
        this.cupom.data_fim = hoje.add(28, 'day').format('YYYY-MM-DD');
      } else if (preset === '3m') {
        this.cupom.data_inicio = hoje.format('YYYY-MM-DD');
        this.cupom.data_fim = hoje.add(3, 'month').format('YYYY-MM-DD');
      } else if (preset === 'personalizado') {
        this.cupom.data_inicio = null;
        this.cupom.data_fim = null;
      }
    },
    async validar () {
      try {
        const result = await this.$validator.validateAll('form');
        const codeValid = Boolean(this.cupom.codigo && this.cupom.codigo.length >= 5);
        const validAmount = Boolean(this.cupom.quantidade > this.cupom.utilizados);

        if (this.cupom.utilizados && this.cupom.utilizados != 0 && !validAmount) {
          throw 'A quantidade deve ser maior que os cupons já utilizados';
        }
        if (!result || (this.aplicarEm === 'itens' && this.cupom.tipo_desconto == 2 && this.cupom.valor_desconto_maximo < 1)) {
          throw 'Preencha todos os campos corretamente!';
        }
        if (this.aplicarEm === 'itens' && this.cupom.tipo_desconto == 2 && !this.cupom.id) {
          var pct = Number(this.cupom.valor_desconto);
          if (isNaN(pct) || pct < 10 || pct > 90) {
            throw 'O percentual do cupom deve ser entre 10% e 90%.';
          }
        }
        if (!codeValid) {
          throw 'O código não pode ter menos de 5 caractéres';
        }
        if (this.cupom.vigencia == 1 && this.$dayjs(this.cupom.data_inicio).isAfter(this.cupom.data_fim)) {
          throw 'A data inicial precisa ser menor que a data final!';
        }
        await this.salvar();
        this.$validator.reset();
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: error });
        this.loading = false;
      }
    },
    async salvar () {
      try {
        if (!this.diasSemanaSel.length) {
          return window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Selecione pelo menos um dia da semana.' });
        }
        if (this.aplicarEm === 'entrega' && !this.regraDescontoEntrega) {
          return window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Selecione o limite do desconto na taxa de entrega.' });
        }

        const isEdicao = !!this.cupom.id;

        if (!isEdicao) {
          const codigoUpper = (this.cupom.codigo || '').toUpperCase();
          const duplicado = _.find(this.cupons, o =>
            o.id !== this.cupom.id &&
            o.codigo === codigoUpper &&
            o.ativo === 1 &&
            o.disponiveis > 0 &&
            o.status === 1
          );
          if (duplicado) {
            return window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Já existe um cupom com o mesmo código informado, altere o código ou desative-o antes de cadastrar um novo.' });
          }
          const suffix = (this.isCardapioDigital ? '.' : ' do Bigou Delivery.') + '<br>Deseja continuar?';
          const msg = 'Ao salvar o cupom, você concorda que o desconto é concedido pelo estabelecimento sem possibilidade de ressarcimento' + suffix;
          const res = await this.$confirm(msg, { title: 'Atenção' });
          if (!res) return;
        }

        this.loading = true;
        const obj = montarPayloadCupom(this.cupom, {
          fromTemplate: false,
          estabelecimento: this.estabelecimento,
          isCardapioDigital: this.isCardapioDigital,
          aplicarEm: this.aplicarEm,
          minPedidoEntregaSelecionado: this.minPedidoEntregaSelecionado,
          regraDescontoEntrega: this.regraDescontoEntrega,
          valorDescontoMaximoEntrega: this.valorDescontoMaximoEntrega,
          diasSemanaSel: this.diasSemanaSel,
        });

        if (isEdicao) {
          await this.$axios.put('/cupom-desconto', obj);
          window.getApp.$emit('APP_ALERT', { color: 'success', text: `${obj.codigo} editado com sucesso!` });
        } else {
          await this.$axios.post('/cupom-desconto', obj);
          this.$firebase.logEvent('coupon_created', {
            from_template: false,
            coupon_type: this.cupom.tipo_desconto,
            coupon_code: obj.codigo,
            establishment_id: this.estabelecimento ? this.estabelecimento.id : null,
          });
          window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Cupom salvo com sucesso!' });
        }

        this.loading = false;
        this.$emit('saved');

        const cupomArte = isEdicao ? null : {
          ...obj,
          entrega_gratis: this.cupom.entrega_gratis,
          taxa_entrega: obj.taxa_entrega,
        };
        this.close();
        if (cupomArte) {
          this.$emit('ativado', cupomArte);
        }
      } catch (error) {
        const err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar o cupom de desconto!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
// Estilos do modal de cupom (replicados de Lista.vue para manter o componente
// autossuficiente). Regras globais — alcançam os elementos internos do Vuetify.
.gestaoCupom .cardApple {
  background-color: rgba(250, 250, 252, 0.8) !important;
  backdrop-filter: saturate(180%) blur(20px);
  box-shadow: none !important;
}
.gestaoCupom .inputDefault .v-input__control .v-input__slot {
  background-color: #f6f6f6 !important;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, .15) !important;
}
.gestaoCupom .inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot {
  border: 1px solid #1d9a5a !important;
}
.gestaoCupom .cupom-codigo-input input {
  text-transform: uppercase;
}
.gestaoCupom .areaPontilhada {
  border-radius: 13px !important;
  border: 1px dashed rgba(0, 0, 0, 0.54);
  padding: 7px 12px !important;

  .v-input__control {
    width: 100% !important;
  }
  .v-input__control .v-input__slot .v-input--radio-group__input {
    display: flex !important;
    justify-content: space-evenly;

    .v-radio {
      margin: 0 !important;
    }
  }
}
.gestaoCupom .padraoBtn {
  height: 40px !important;
  width: 100px !important;
  border-radius: 5px !important;
  font-weight: 500;
  box-shadow: none !important;
}
.gestaoCupom .Poppins {
  font-family: "Poppins", "Roboto", "Helvetica" !important;
}
.gestaoCupom .cupom-smart-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(29, 154, 90, 0.12);
  color: #1d9a5a;
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  vertical-align: middle;
}
.gestaoCupom .cupomDialog__field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888;
  margin-bottom: 8px;
  font-family: 'Poppins', sans-serif;
  display: flex;
  align-items: center;
}
.gestaoCupom .cupomDialog__field-hint {
  font-size: 11px;
  font-weight: 500;
  color: #1d9a5a;
  margin-top: -4px;
  margin-bottom: 8px;
  font-family: 'Poppins', sans-serif;
}
.gestaoCupom .cupomDialog__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.gestaoCupom .cupomDialog__chip {
  padding: 6px 16px;
  border-radius: 20px;
  border: 1.5px solid #d2d2d7;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  color: #444;
  background: #fff;
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  &--active {
    border-color: #1d9a5a;
    color: #1d9a5a;
    background: rgba(29, 154, 90, 0.08);
  }
  &--smart {
    border-color: rgba(29, 154, 90, 0.45);
    background: rgba(29, 154, 90, 0.05);
  }
}
.gestaoCupom .cupomDialog__chip-smart-icon {
  margin-left: 4px;
  margin-top: -4px;
  align-self: center;
  color: #1d9a5a !important;
}
</style>
